<ion-toolbar class="search-toolbar container second-toolbar">
  <ion-searchbar [(ngModel)]="search.query" (ionInput)="runSearch($event)" [placeholder]="placeholder || ('search_something'|translate)"></ion-searchbar>
</ion-toolbar>